var _require = require('prettier/standalone'),
    join = _require.doc.builders.join;

var AssemblyAssignment = {
  print: function print(_ref) {
    var path = _ref.path,
        _print = _ref.print;
    return join(' ', [join(', ', path.map(_print, 'names')), ':=', path.call(_print, 'expression')]);
  }
};
module.exports = AssemblyAssignment;